import { LazyLoadImage } from "react-lazy-load-image-component";

export const ImagesData = ({ imagesData }) => {
  // console.log("imagesData", imagesData);
  if (imagesData?.length) {
    return (
      <div className="flex justify-center  gap-5 flex-wrap my-2">
        {imagesData.length > 0 &&
          imagesData.map((imgUrl, index) => (
            <div
              key={index}
              className="w-52 h-52 overflow-hidden shadow-2xl border  text-center rounded-xl relative"
            >
              <label htmlFor={`variant-${index}`}>
                <LazyLoadImage
                  src={imgUrl?.image|| imgUrl}
                  alt="variant_image"
                  loading="lazy"
                  effect="blur"
                  className="w-[100%] h-[100%] object-contain rounded-xl cursor-pointer"
                />
              </label>
            </div>
          ))}
      </div>
    );
  }
};
